interface IconProps {
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  width?: number;
  height?: number;
  onClick?: (e) => void;
  className?: string;
}

export const IconTool: React.FC<IconProps> = ({
  stroke = 'currentColor',
  fill = '',
}) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0096 4.64939C20.9556 4.54435 20.8776 4.45356 20.7818 4.3844C20.6861 4.31523 20.5754 4.26966 20.4587 4.25138C20.342 4.23311 20.2226 4.24265 20.1103 4.27923C19.998 4.31581 19.896 4.37839 19.8124 4.46189L16.9324 7.34376C16.7911 7.48309 16.6005 7.56119 16.4021 7.56119C16.2036 7.56119 16.013 7.48309 15.8717 7.34376L14.6267 6.09689C14.557 6.02724 14.5017 5.94455 14.464 5.85355C14.4263 5.76254 14.4069 5.665 14.4069 5.5665C14.4069 5.46799 14.4263 5.37045 14.464 5.27945C14.5017 5.18844 14.557 5.10575 14.6267 5.03611L17.4945 2.16783C17.5804 2.08187 17.6442 1.9763 17.6803 1.86021C17.7164 1.74413 17.7238 1.621 17.7017 1.50144C17.6797 1.38189 17.6289 1.26948 17.5538 1.17391C17.4786 1.07834 17.3814 1.00247 17.2704 0.952829C15.1043 -0.0156081 12.4006 0.489704 10.6957 2.18189C9.24728 3.62001 8.81557 5.8672 9.51213 8.34735C9.54968 8.47961 9.5499 8.61969 9.51275 8.75206C9.47561 8.88444 9.40254 9.00394 9.30166 9.09735L1.49791 16.2247C1.1939 16.4977 0.948681 16.8297 0.777217 17.2005C0.605753 17.5714 0.511636 17.9733 0.500608 18.3817C0.48958 18.7901 0.561871 19.1965 0.713073 19.5761C0.864275 19.9556 1.09122 20.3004 1.38006 20.5894C1.66889 20.8783 2.01357 21.1054 2.39307 21.2568C2.77256 21.4082 3.17892 21.4806 3.58734 21.4698C3.99577 21.4589 4.3977 21.365 4.76863 21.1937C5.13955 21.0224 5.47169 20.7773 5.74479 20.4734L12.9485 12.6524C13.0406 12.5528 13.1581 12.4802 13.2884 12.4424C13.4186 12.4047 13.5567 12.4032 13.6878 12.4381C14.3939 12.6316 15.1222 12.732 15.8543 12.7367C17.4199 12.7367 18.7938 12.23 19.7848 11.2536C21.6199 9.44563 21.8998 6.37907 21.0096 4.64939ZM3.66307 19.9602C3.35435 19.9939 3.04278 19.9309 2.77136 19.78C2.49994 19.6291 2.28206 19.3976 2.14778 19.1176C2.0135 18.8376 1.96944 18.5228 2.02168 18.2167C2.07393 17.9105 2.2199 17.6282 2.43946 17.4085C2.65901 17.1889 2.94132 17.0428 3.24743 16.9905C3.55354 16.9381 3.86835 16.9821 4.14842 17.1163C4.42849 17.2504 4.66 17.4683 4.81102 17.7396C4.96203 18.011 5.02509 18.3225 4.9915 18.6313C4.95455 18.9709 4.80272 19.2878 4.56115 19.5295C4.31958 19.7711 4.00274 19.9231 3.66307 19.9602Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};

export const IconShirt: React.FC<IconProps> = ({
  stroke = 'currentColor',
  fill = '',
}) => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4528 1.46844C15.2402 2.26726 14.7697 2.97348 14.1143 3.47726C13.4589 3.98105 12.6555 4.25417 11.8289 4.25417C11.0022 4.25417 10.1988 3.98105 9.54341 3.47726C8.88805 2.97348 8.41751 2.26726 8.20495 1.46844M14.5739 1.25C14.5739 1.25 13.506 1.625 11.8289 1.625C10.1517 1.625 9.08386 1.25 9.08386 1.25C8.91513 1.25 8.74761 1.27853 8.58839 1.33437L1.32886 3.875L2.10839 8L4.39964 8.25875C4.68023 8.2905 4.93862 8.42662 5.1235 8.64007C5.30838 8.85352 5.40622 9.12869 5.39761 9.41094L5.07886 20.75H18.5789L18.2601 9.41094C18.2515 9.12869 18.3493 8.85352 18.5342 8.64007C18.7191 8.42662 18.9775 8.2905 19.2581 8.25875L21.5493 8L22.3289 3.875L15.0693 1.33437C14.9101 1.27853 14.7426 1.25 14.5739 1.25Z"
        stroke={stroke}
        strokeWidth="2"
        fill={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconCalendar: React.FC<IconProps> = ({
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 3.75H5C3.75736 3.75 2.75 4.75736 2.75 6V19.5C2.75 20.7426 3.75736 21.75 5 21.75H20C21.2426 21.75 22.25 20.7426 22.25 19.5V6C22.25 4.75736 21.2426 3.75 20 3.75Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 7.5H2.75M6.5 2.25V3.75V2.25ZM18.5 2.25V3.75V2.25Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconChat: React.FC<IconProps> = ({
  stroke = 'currentColor',
  fill = 'none',
}) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.375 1H4.125C3.42942 1.00198 2.76289 1.27918 2.27103 1.77103C1.77918 2.26289 1.50198 2.92942 1.5 3.625V12.625C1.50198 13.3206 1.77918 13.9871 2.27103 14.479C2.76289 14.9708 3.42942 15.248 4.125 15.25H6V19L10.3931 15.3372C10.4606 15.2808 10.5457 15.25 10.6336 15.25H18.375C19.0706 15.248 19.7371 14.9708 20.229 14.479C20.7208 13.9871 20.998 13.3206 21 12.625V3.625C20.998 2.92942 20.7208 2.26289 20.229 1.77103C19.7371 1.27918 19.0706 1.00198 18.375 1V1Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconProfile: React.FC<IconProps> = ({
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1251 6.75C15.9413 9.22828 14.0625 11.25 12 11.25C9.93754 11.25 8.05551 9.22875 7.87504 6.75C7.68754 4.17188 9.51567 2.25 12 2.25C14.4844 2.25 16.3126 4.21875 16.1251 6.75Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.25C7.92187 14.25 3.7828 16.5 3.01687 20.7469C2.92452 21.2588 3.21421 21.75 3.74999 21.75H20.25C20.7863 21.75 21.0759 21.2588 20.9836 20.7469C20.2172 16.5 16.0781 14.25 12 14.25Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const IconFilter: React.FC<IconProps> = ({ onClick = () => null }) => {
  return (
    <svg
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 5.625H23.25V7.875H0.75V5.625ZM4.5 10.875H19.5V13.125H4.5V10.875ZM9 16.125H15V18.375H9V16.125Z"
        fill="#1D1D1F"
      />
    </svg>
  );
};

export const IconBell = () => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8555 20.3846V21.3077C15.8555 22.287 15.4664 23.2261 14.774 23.9185C14.0816 24.611 13.1424 25 12.1631 25C11.1839 25 10.2447 24.611 9.55229 23.9185C8.85985 23.2261 8.47084 22.287 8.47084 21.3077V20.3846M22.0678 18.5056C20.5862 16.6923 19.5403 15.7692 19.5403 10.7702C19.5403 6.19231 17.2026 4.56135 15.2785 3.76923C15.023 3.66423 14.7824 3.42308 14.7045 3.16058C14.367 2.01192 13.4208 1 12.1631 1C10.9055 1 9.95872 2.0125 9.62468 3.16173C9.5468 3.42712 9.30622 3.66423 9.05065 3.76923C7.1243 4.5625 4.78891 6.18769 4.78891 10.7702C4.78603 15.7692 3.74007 16.6923 2.25853 18.5056C1.64468 19.2567 2.18238 20.3846 3.25603 20.3846H21.076C22.1439 20.3846 22.6781 19.2533 22.0678 18.5056Z"
        stroke="#1D1D1F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSearch: React.FC<IconProps> = ({
  stroke = 'currentColor',
  onClick = () => null,
}) => {
  return (
    <svg
      onClick={onClick}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7243 1C8.80102 1 6.92092 1.57032 5.32177 2.63884C3.72262 3.70736 2.47623 5.22609 1.74022 7.00297C1.00421 8.77985 0.81164 10.7351 1.18685 12.6214C1.56207 14.5077 2.48822 16.2404 3.84818 17.6004C5.20815 18.9604 6.94086 19.8865 8.82718 20.2617C10.7135 20.637 12.6687 20.4444 14.4456 19.7084C16.2225 18.9724 17.7412 17.726 18.8098 16.1268C19.8783 14.5277 20.4486 12.6476 20.4486 10.7243C20.4484 8.1453 19.4239 5.67198 17.6002 3.84836C15.7766 2.02474 13.3033 1.00016 10.7243 1V1Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9653 17.9634L24.9999 24.998"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconHeart: React.FC<IconProps> = ({
  fill = '',
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5431 1.75C11.5 1.75 9.99999 4.75 9.99999 4.75C9.99999 4.75 8.49999 1.75 5.45687 1.75C2.98374 1.75 1.0253 3.81906 0.999991 6.28797C0.948428 11.4128 5.06546 15.0573 9.57812 18.1202C9.70253 18.2048 9.84952 18.2501 9.99999 18.2501C10.1505 18.2501 10.2975 18.2048 10.4219 18.1202C14.9341 15.0573 19.0511 11.4128 19 6.28797C18.9747 3.81906 17.0162 1.75 14.5431 1.75V1.75Z"
        stroke={stroke}
        strokeWidth="2"
        fill={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconStar: React.FC<IconProps> = ({
  fill = 'transparent',
  stroke = 'currentColor',
  strokeWidth = 2,
  width = 24,
  height = 22,
  onClick = () => null,
}) => {
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 8.75H14.4375L12 1.25L9.5625 8.75H1.5L8.0625 13.25L5.53125 20.75L12 16.0625L18.4688 20.75L15.9375 13.25L22.5 8.75Z"
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconVerificated = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 8.25L10.5562 14.25L8.25 11.9906"
        stroke="#1D1D1F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7078 5.26734C17.5162 4.51547 15.7832 3.95859 12 2.25C8.21667 3.95859 6.48371 4.51547 2.29215 5.26734C1.53277 17.303 11.2771 21.4589 12 21.75C12.7228 21.4589 22.4671 17.303 21.7078 5.26734Z"
        stroke="#1D1D1F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconLocation = () => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
        fill="#1D1D1F"
      />
      <path
        d="M10 0C4.48625 0 0 4.29063 0 9.5625C0 12.0731 1.14437 15.4119 3.40125 19.4863C5.21375 22.7575 7.31063 25.7156 8.40125 27.1875C8.58554 27.439 8.8265 27.6435 9.10459 27.7845C9.38269 27.9255 9.69009 27.999 10.0019 27.999C10.3137 27.999 10.6211 27.9255 10.8992 27.7845C11.1772 27.6435 11.4182 27.439 11.6025 27.1875C12.6913 25.7156 14.79 22.7575 16.6025 19.4863C18.8556 15.4131 20 12.0744 20 9.5625C20 4.29063 15.5138 0 10 0ZM10 14C9.20887 14 8.43552 13.7654 7.77772 13.3259C7.11992 12.8864 6.60723 12.2616 6.30448 11.5307C6.00173 10.7998 5.92252 9.99556 6.07686 9.21964C6.2312 8.44372 6.61216 7.73098 7.17157 7.17157C7.73098 6.61216 8.44372 6.2312 9.21964 6.07686C9.99556 5.92252 10.7998 6.00173 11.5307 6.30448C12.2616 6.60723 12.8864 7.11992 13.3259 7.77772C13.7654 8.43552 14 9.20888 14 10C13.9988 11.0605 13.577 12.0773 12.8271 12.8272C12.0773 13.577 11.0605 13.9988 10 14Z"
        fill="#1D1D1F"
      />
    </svg>
  );
};

export const IconChevronRight: React.FC<IconProps> = ({
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.625 14.9854L8.375 8.23535L1.625 1.48535"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const IconClose: React.FC<IconProps> = ({
  fill = 'currentColor',
  width = 20,
  onClick,
}) => {
  return (
    <svg
      onClick={onClick}
      width={width}
      height={width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4556 10.014L19.6753 1.83005C20.0694 1.43951 20.0694 0.807303 19.6753 0.417765C19.2823 0.0272311 18.6438 0.0272311 18.2507 0.417765L10.038 8.59473L1.74938 0.295889C1.3563 -0.0986297 0.717831 -0.0986297 0.324749 0.295889C-0.0683333 0.691404 -0.0683333 1.33158 0.324749 1.7261L8.60734 10.019L0.294812 18.2948C-0.0982705 18.6854 -0.0982705 19.3176 0.294812 19.7071C0.687894 20.0976 1.32636 20.0976 1.71944 19.7071L10.0249 11.4382L18.2806 19.7041C18.6736 20.0986 19.3121 20.0986 19.7052 19.7041C20.0983 19.3086 20.0983 18.6684 19.7052 18.2739L11.4556 10.014Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconExclamation: React.FC<IconProps> = ({
  fill = 'currentColor',
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0C5.83187 0 0 5.83187 0 13C0 20.1681 5.83187 26 13 26C20.1681 26 26 20.1681 26 13C26 5.83187 20.1681 0 13 0ZM13 19.9944C12.7528 19.9944 12.5111 19.9211 12.3055 19.7837C12.1 19.6464 11.9398 19.4511 11.8452 19.2227C11.7505 18.9943 11.7258 18.743 11.774 18.5005C11.8222 18.258 11.9413 18.0353 12.1161 17.8605C12.2909 17.6857 12.5137 17.5666 12.7561 17.5184C12.9986 17.4702 13.2499 17.4949 13.4784 17.5895C13.7068 17.6841 13.902 17.8444 14.0393 18.0499C14.1767 18.2555 14.25 18.4971 14.25 18.7444C14.25 19.0759 14.1183 19.3938 13.8839 19.6283C13.6495 19.8627 13.3315 19.9944 13 19.9944ZM14.3575 7.4225L13.9988 15.0475C13.9988 15.3127 13.8934 15.5671 13.7059 15.7546C13.5183 15.9421 13.264 16.0475 12.9987 16.0475C12.7335 16.0475 12.4792 15.9421 12.2916 15.7546C12.1041 15.5671 11.9987 15.3127 11.9987 15.0475L11.64 7.42625V7.42313C11.6321 7.23995 11.6614 7.05709 11.7261 6.88553C11.7908 6.71398 11.8895 6.55729 12.0163 6.4249C12.1432 6.29251 12.2955 6.18716 12.4641 6.11518C12.6327 6.04321 12.8142 6.00611 12.9975 6.00611C13.1808 6.00611 13.3623 6.04321 13.5309 6.11518C13.6995 6.18716 13.8518 6.29251 13.9787 6.4249C14.1055 6.55729 14.2042 6.71398 14.2689 6.88553C14.3336 7.05709 14.3629 7.23995 14.355 7.42313L14.3575 7.4225Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconClock: React.FC<IconProps> = ({ fill = 'currentColor' }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 0.117676C5.37252 0.117676 0 5.49035 0 12.1174C0 18.7444 5.37252 24.1177 11.9997 24.1177C18.6269 24.1177 23.9998 18.7446 23.9998 12.1174C23.9998 5.49011 18.6269 0.117676 11.9998 0.117676ZM12.8284 13.5847C12.8278 13.6162 12.8231 13.6478 12.8187 13.6794C12.8155 13.703 12.8141 13.7273 12.8087 13.7506C12.8034 13.7748 12.7942 13.7987 12.7863 13.823C12.777 13.8522 12.7683 13.8814 12.756 13.909C12.7537 13.9138 12.7529 13.919 12.7508 13.9238C12.7327 13.9623 12.7118 13.9985 12.6888 14.0327C12.6874 14.0348 12.6855 14.0369 12.684 14.039C12.6579 14.0774 12.628 14.1122 12.5967 14.145C12.5879 14.1539 12.5791 14.162 12.5699 14.1705C12.5423 14.1968 12.5132 14.2209 12.4823 14.2429C12.4728 14.2498 12.4637 14.257 12.4537 14.2636C12.4141 14.2895 12.3726 14.3123 12.3294 14.3311C12.32 14.3352 12.3102 14.3377 12.3007 14.3415C12.2642 14.3555 12.2273 14.3672 12.1891 14.3761C12.1754 14.3794 12.1619 14.3823 12.148 14.3848C12.099 14.3938 12.0494 14.3999 11.9992 14.3999C11.989 14.3999 11.9786 14.3968 11.9685 14.3964C11.9203 14.3946 11.8726 14.3908 11.8268 14.3811C11.8125 14.3779 11.7984 14.3717 11.7841 14.3678C11.7414 14.3562 11.6996 14.3433 11.6598 14.3254C11.6552 14.3231 11.6504 14.3227 11.6458 14.3207L7.04461 12.1503C6.63005 11.9549 6.45245 11.4602 6.64789 11.0457C6.84333 10.6313 7.33797 10.4535 7.75254 10.6489L11.1698 12.2605V5.09763C11.1698 4.63931 11.5414 4.2677 11.9998 4.2677C12.4581 4.2677 12.8297 4.63931 12.8297 5.09763V13.5698H12.8299C12.8299 13.5747 12.8284 13.5797 12.8284 13.5847Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconReturn: React.FC<IconProps> = ({ fill = 'currentColor' }) => {
  return (
    <svg
      width="25"
      height="24"
      fill="none"
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6523 5.25L8.90234 12L15.6523 18.75"
        stroke={fill}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const IconEdit: React.FC<IconProps> = ({ fill = 'currentColor' }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.1529 2.91213C25.073 2.82432 24.9761 2.75363 24.8681 2.70432C24.7601 2.65501 24.6432 2.62812 24.5245 2.62526C24.4059 2.62239 24.2878 2.64362 24.1776 2.68767C24.0673 2.73171 23.9671 2.79765 23.8831 2.8815L23.2066 3.5547C23.1246 3.63674 23.0785 3.74798 23.0785 3.86396C23.0785 3.97994 23.1246 4.09118 23.2066 4.17322L23.8267 4.79228C23.8674 4.83312 23.9157 4.86553 23.9689 4.88764C24.0221 4.90976 24.0792 4.92114 24.1368 4.92114C24.1944 4.92114 24.2515 4.90976 24.3047 4.88764C24.3579 4.86553 24.4062 4.83312 24.4469 4.79228L25.1064 4.13603C25.44 3.80298 25.4712 3.26048 25.1529 2.91213ZM21.8389 4.92189L11.9667 14.7766C11.9068 14.8362 11.8633 14.9102 11.8403 14.9915L11.3837 16.3516C11.3728 16.3885 11.372 16.4277 11.3815 16.465C11.3909 16.5023 11.4103 16.5363 11.4375 16.5635C11.4647 16.5908 11.4988 16.6101 11.5361 16.6196C11.5734 16.6291 11.6126 16.6283 11.6495 16.6174L13.0085 16.1607C13.0898 16.1377 13.1638 16.0942 13.2234 16.0344L23.0781 6.16111C23.1692 6.06896 23.2204 5.94457 23.2204 5.81494C23.2204 5.68531 23.1692 5.56091 23.0781 5.46877L22.5339 4.92189C22.4417 4.82989 22.3167 4.77822 22.1864 4.77822C22.0561 4.77822 21.9311 4.82989 21.8389 4.92189Z"
        fill={fill}
      />
      <path
        d="M21.128 10.5908L14.4621 17.2698C14.2045 17.528 13.8878 17.7197 13.5395 17.8281L12.1231 18.3023C11.787 18.3972 11.4316 18.4008 11.0936 18.3126C10.7556 18.2245 10.4472 18.0478 10.2002 17.8008C9.95326 17.5539 9.77659 17.2455 9.68846 16.9075C9.60032 16.5695 9.6039 16.2141 9.69883 15.878L10.173 14.4616C10.2811 14.1134 10.4724 13.7967 10.7302 13.539L17.4092 6.87203C17.4704 6.81088 17.5122 6.73294 17.5291 6.64808C17.546 6.56322 17.5374 6.47524 17.5043 6.39528C17.4712 6.31532 17.4152 6.24696 17.3433 6.19885C17.2713 6.15074 17.1868 6.12504 17.1002 6.125H5.6875C4.87527 6.125 4.09632 6.44766 3.52199 7.02199C2.94766 7.59632 2.625 8.37527 2.625 9.1875V22.3125C2.625 23.1247 2.94766 23.9037 3.52199 24.478C4.09632 25.0523 4.87527 25.375 5.6875 25.375H18.8125C19.6247 25.375 20.4037 25.0523 20.978 24.478C21.5523 23.9037 21.875 23.1247 21.875 22.3125V10.8998C21.875 10.8132 21.8493 10.7287 21.8011 10.6567C21.753 10.5848 21.6847 10.5288 21.6047 10.4957C21.5248 10.4626 21.4368 10.454 21.3519 10.4709C21.2671 10.4878 21.1891 10.5296 21.128 10.5908Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconInterrogation: React.FC<IconProps> = ({
  fill = 'currentColor',
  stroke = '#FFF',
  width = 24,
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill={fill} />
      <path
        d="M11.8569 3.37012C14.9124 3.37012 17.9185 4.77452 17.9135 8.13374C17.9088 11.2315 14.3502 12.4229 13.5846 13.5422C13.0099 14.3749 13.1997 15.5448 11.6241 15.5448C10.5977 15.5448 10.0976 14.7116 10.0987 13.9493C10.1029 11.1123 14.2804 10.4703 14.2839 8.13431C14.2859 6.84853 13.4296 6.08617 11.9965 6.08617C8.94099 6.08617 10.1294 9.23006 7.81526 9.23006C6.97984 9.23006 6.26347 8.72969 6.26489 7.7773C6.26782 5.44075 8.94392 3.37012 11.8569 3.37012ZM11.7175 17.0915C12.7901 17.0915 13.6738 17.9719 13.6722 19.0457C13.6706 20.1196 12.7859 21 11.7117 21C10.6374 21 9.75485 20.1207 9.75646 19.0457C9.75806 17.9725 10.6432 17.0915 11.7175 17.0915Z"
        fill={stroke}
      />
    </svg>
  );
};

export const IconThumbsUp: React.FC<IconProps> = ({
  fill = 'currentColor',
}) => {
  return (
    <svg
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.375 7.99917L14.575 7.39917L15.725 2.92917C16.025 1.59917 15.686 0.835674 14.6015 0.499174L12.867 0.00667437C12.8259 -0.00420514 12.7825 -0.00173533 12.7429 0.0137264C12.7034 0.0291882 12.6698 0.056839 12.647 0.0926742L6.197 10.2097C6.16123 10.2679 6.11116 10.3159 6.05155 10.3493C5.99195 10.3826 5.9248 10.4001 5.8565 10.4002H0.375V20.7992H6.2555C6.51347 20.7991 6.76975 20.8406 7.0145 20.9222L10.8295 22.1937C11.2374 22.3297 11.6645 22.3991 12.0945 22.3992H20.991C21.941 22.3992 22.566 21.7232 22.7525 20.7912L24.375 13.6782V9.99917C24.375 8.89617 23.475 8.09917 22.375 7.99917Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconTip: React.FC<IconProps> = ({ fill = 'currentColor' }) => {
  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50002 21.75H6.50002C6.30111 21.75 6.11034 21.829 5.96969 21.9697C5.82904 22.1103 5.75002 22.3011 5.75002 22.5C5.75002 22.6989 5.82904 22.8897 5.96969 23.0304C6.11034 23.171 6.30111 23.25 6.50002 23.25H9.50002C9.69893 23.25 9.8897 23.171 10.0304 23.0304C10.171 22.8897 10.25 22.6989 10.25 22.5C10.25 22.3011 10.171 22.1103 10.0304 21.9697C9.8897 21.829 9.69893 21.75 9.50002 21.75ZM10.25 19.5H5.75002C5.55111 19.5 5.36034 19.579 5.21969 19.7197C5.07904 19.8603 5.00002 20.0511 5.00002 20.25C5.00002 20.4489 5.07904 20.6397 5.21969 20.7804C5.36034 20.921 5.55111 21 5.75002 21H10.25C10.4489 21 10.6397 20.921 10.7804 20.7804C10.921 20.6397 11 20.4489 11 20.25C11 20.0511 10.921 19.8603 10.7804 19.7197C10.6397 19.579 10.4489 19.5 10.25 19.5ZM13.3166 2.93862C11.9071 1.52721 10.0189 0.750021 8.00002 0.750021C7.01445 0.747672 6.03812 0.940062 5.12712 1.31614C4.21612 1.69222 3.38839 2.24457 2.69148 2.94148C1.99457 3.63839 1.44222 4.46612 1.06614 5.37712C0.690062 6.28812 0.497672 7.26445 0.500021 8.25002C0.500021 10.4353 1.33768 12.4796 2.7969 13.8581L3.00127 14.0499C3.84549 14.8392 5.00002 15.9206 5.00002 16.875V18C5.00002 18.1989 5.07904 18.3897 5.21969 18.5304C5.36034 18.671 5.55111 18.75 5.75002 18.75H6.87502C6.97448 18.75 7.06986 18.7105 7.14019 18.6402C7.21051 18.5699 7.25002 18.4745 7.25002 18.375V12.8822C7.25005 12.8064 7.22708 12.7323 7.18415 12.6698C7.14121 12.6073 7.08034 12.5593 7.00955 12.5321C6.57647 12.3554 6.16504 12.1297 5.7833 11.8594C5.69752 11.8046 5.62378 11.7329 5.56658 11.6488C5.50938 11.5646 5.46992 11.4696 5.4506 11.3697C5.43127 11.2697 5.43249 11.1669 5.45418 11.0675C5.47587 10.968 5.51757 10.874 5.57675 10.7912C5.63593 10.7084 5.71135 10.6385 5.79841 10.5858C5.88547 10.5331 5.98235 10.4986 6.08315 10.4845C6.18396 10.4704 6.28657 10.477 6.38476 10.5038C6.48294 10.5307 6.57463 10.5772 6.65424 10.6406C7.00111 10.8863 7.66908 11.25 8.00002 11.25C8.33096 11.25 8.99893 10.8853 9.34674 10.6406C9.50869 10.5388 9.70342 10.5027 9.89109 10.5398C10.0788 10.5768 10.2452 10.6841 10.3563 10.8398C10.4675 10.9955 10.5149 11.1878 10.489 11.3773C10.463 11.5669 10.3656 11.7393 10.2167 11.8594C9.83493 12.1292 9.42351 12.3544 8.99049 12.5306C8.9197 12.5579 8.85883 12.6059 8.8159 12.6684C8.77297 12.7309 8.75 12.805 8.75002 12.8808V18.375C8.75002 18.4745 8.78953 18.5699 8.85986 18.6402C8.93018 18.7105 9.02557 18.75 9.12502 18.75H10.25C10.4489 18.75 10.6397 18.671 10.7804 18.5304C10.921 18.3897 11 18.1989 11 18V16.875C11 15.9431 12.1419 14.8627 12.9758 14.0733L13.206 13.8549C14.7069 12.4219 15.5 10.4817 15.5 8.25002C15.505 7.26436 15.3146 6.28747 14.9398 5.37582C14.5651 4.46417 14.0133 3.63581 13.3166 2.93862Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconImageUpload: React.FC<IconProps> = ({ fill = '#ffffff' }) => {
  return (
    <svg
      width="41"
      height="37"
      viewBox="0 0 41 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.875 10V6.875H39C39.3315 6.875 39.6495 6.7433 39.8839 6.50888C40.1183 6.27446 40.25 5.95652 40.25 5.625C40.25 5.29348 40.1183 4.97554 39.8839 4.74112C39.6495 4.5067 39.3315 4.375 39 4.375H35.875V1.25C35.875 0.918479 35.7433 0.600537 35.5089 0.366117C35.2745 0.131696 34.9565 0 34.625 0C34.2935 0 33.9755 0.131696 33.7411 0.366117C33.5067 0.600537 33.375 0.918479 33.375 1.25V4.375H30.25C29.9185 4.375 29.6005 4.5067 29.3661 4.74112C29.1317 4.97554 29 5.29348 29 5.625C29 5.95652 29.1317 6.27446 29.3661 6.50888C29.6005 6.7433 29.9185 6.875 30.25 6.875H33.375V10C33.375 10.3315 33.5067 10.6495 33.7411 10.8839C33.9755 11.1183 34.2935 11.25 34.625 11.25C34.9565 11.25 35.2745 11.1183 35.5089 10.8839C35.7433 10.6495 35.875 10.3315 35.875 10Z"
        fill={fill}
      />
      <path
        d="M26 8.91992H6C4.93949 8.92106 3.92275 9.33442 3.17285 10.0693C2.42296 10.8042 2.00116 11.8006 2 12.8399V28.5199C2.00116 29.5592 2.42296 30.5556 3.17285 31.2905C3.92275 32.0254 4.93949 32.4388 6 32.4399H26C27.0605 32.4388 28.0773 32.0254 28.8271 31.2905C29.577 30.5556 29.9988 29.5592 30 28.5199V12.8399C29.9988 11.8006 29.577 10.8042 28.8271 10.0693C28.0773 9.33442 27.0605 8.92106 26 8.91992ZM21 12.8399C21.5933 12.8399 22.1734 13.0124 22.6667 13.3354C23.1601 13.6585 23.5446 14.1176 23.7716 14.6548C23.9987 15.192 24.0581 15.7832 23.9424 16.3535C23.8266 16.9238 23.5409 17.4476 23.1213 17.8588C22.7018 18.27 22.1672 18.55 21.5853 18.6634C21.0033 18.7769 20.4001 18.7186 19.8519 18.4961C19.3038 18.2736 18.8352 17.8968 18.5056 17.4133C18.1759 16.9298 18 16.3614 18 15.7799C18.0008 15.0004 18.3172 14.2531 18.8796 13.7019C19.442 13.1507 20.2046 12.8407 21 12.8399ZM6 30.4799C5.46957 30.4799 4.96086 30.2734 4.58579 29.9059C4.21071 29.5383 4 29.0397 4 28.5199V24.3776L9.9275 19.2142C10.4994 18.7171 11.2432 18.4525 12.0073 18.4741C12.7714 18.4957 13.4983 18.802 14.04 19.3306L18.0994 23.3002L10.7731 30.4799H6ZM28 28.5199C28 29.0397 27.7893 29.5383 27.4142 29.9059C27.0391 30.2734 26.5304 30.4799 26 30.4799H13.6019L21.1906 23.0429C21.7279 22.5952 22.4097 22.3485 23.115 22.3467C23.8203 22.3449 24.5035 22.5881 25.0431 23.0331L28 25.4476V28.5199Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconVideoUpload: React.FC<IconProps> = ({ fill = '#ffffff' }) => {
  return (
    <svg
      width="41"
      height="34"
      viewBox="0 0 41 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29 26.0244C28.72 26.0242 28.4432 25.9652 28.1875 25.8512C28.128 25.8248 28.0713 25.7926 28.0181 25.755L22.8487 22.1162C22.5866 21.9317 22.3726 21.6868 22.2249 21.4023C22.0772 21.1177 22.0001 20.8019 22 20.4813V15.5188C22.0001 15.1981 22.0772 14.8823 22.2249 14.5977C22.3726 14.3132 22.5866 14.0683 22.8487 13.8837L28.0181 10.245C28.0713 10.2074 28.128 10.1752 28.1875 10.1488C28.492 10.0134 28.8255 9.95622 29.1577 9.9825C29.4899 10.0088 29.8103 10.1176 30.0897 10.2992C30.3691 10.4808 30.5988 10.7293 30.7578 11.0222C30.9167 11.3151 31 11.643 31 11.9762V24.0238C31 24.5542 30.7893 25.0629 30.4142 25.438C30.0391 25.813 29.5304 26.0238 29 26.0238V26.0244ZM16.75 27H5.25C4.12319 26.9988 3.04285 26.5507 2.24608 25.7539C1.4493 24.9571 1.00116 23.8768 1 22.75V13.25C1.00116 12.1232 1.4493 11.0429 2.24608 10.2461C3.04285 9.4493 4.12319 9.00116 5.25 9H16.78C17.8988 9.00132 18.9714 9.44635 19.7625 10.2375C20.5536 11.0286 20.9987 12.1012 21 13.22V22.75C20.9988 23.8768 20.5507 24.9571 19.7539 25.7539C18.9571 26.5507 17.8768 26.9988 16.75 27Z"
        fill="white"
      />
      <path
        d="M35.875 10V6.875H39C39.3315 6.875 39.6495 6.7433 39.8839 6.50888C40.1183 6.27446 40.25 5.95652 40.25 5.625C40.25 5.29348 40.1183 4.97554 39.8839 4.74112C39.6495 4.5067 39.3315 4.375 39 4.375H35.875V1.25C35.875 0.918479 35.7433 0.600537 35.5089 0.366117C35.2745 0.131696 34.9565 0 34.625 0C34.2935 0 33.9755 0.131696 33.7411 0.366117C33.5067 0.600537 33.375 0.918479 33.375 1.25V4.375H30.25C29.9185 4.375 29.6005 4.5067 29.3661 4.74112C29.1317 4.97554 29 5.29348 29 5.625C29 5.95652 29.1317 6.27446 29.3661 6.50888C29.6005 6.7433 29.9185 6.875 30.25 6.875H33.375V10C33.375 10.3315 33.5067 10.6495 33.7411 10.8839C33.9755 11.1183 34.2935 11.25 34.625 11.25C34.9565 11.25 35.2745 11.1183 35.5089 10.8839C35.7433 10.6495 35.875 10.3315 35.875 10Z"
        fill={fill}
      />
    </svg>
  );
};

export const IconPlay: React.FC<IconProps> = ({
  fill = '#ffffff',
  className = '',
  onClick = () => null,
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="34"
      height="43"
      viewBox="0 0 34 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 42.9707V0L33.9237 21.4852L0 42.9707Z" fill={fill} />
    </svg>
  );
};

export const IconDottedMenu: React.FC<IconProps> = ({
  fill = '#1D1D1F',
  className = '',
  onClick = () => null,
}) => (
  <svg
    className={className}
    onClick={onClick}
    width="6"
    height="33"
    viewBox="0 0 6 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.08356 15.474C4.61297 15.474 5.85279 14.2342 5.85279 12.7048C5.85279 11.1754 4.61297 9.93555 3.08356 9.93555C1.55416 9.93555 0.314331 11.1754 0.314331 12.7048C0.314331 14.2342 1.55416 15.474 3.08356 15.474Z"
      fill={fill}
    />
    <path
      d="M3.08356 24.7064C4.61297 24.7064 5.85279 23.4666 5.85279 21.9372C5.85279 20.4078 4.61297 19.168 3.08356 19.168C1.55416 19.168 0.314331 20.4078 0.314331 21.9372C0.314331 23.4666 1.55416 24.7064 3.08356 24.7064Z"
      fill={fill}
    />
    <path
      d="M3.08356 6.24354C4.61297 6.24354 5.85279 5.00371 5.85279 3.47431C5.85279 1.9449 4.61297 0.705078 3.08356 0.705078C1.55416 0.705078 0.314331 1.9449 0.314331 3.47431C0.314331 5.00371 1.55416 6.24354 3.08356 6.24354Z"
      fill={fill}
    />
  </svg>
);

export const IconChecked: React.FC<IconProps> = ({ fill = '#1D1D1F' }) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2357 1.15787C17.701 1.56503 17.7481 2.27231 17.341 2.73763L6.84097 14.7376C6.63693 14.9708 6.34538 15.109 6.03569 15.1193C5.72601 15.1296 5.42591 15.0111 5.20681 14.792L0.70681 10.292C0.269605 9.85483 0.269605 9.14598 0.70681 8.70878C1.14401 8.27157 1.85286 8.27157 2.29007 8.70878L5.94391 12.3626L15.6559 1.26319C16.0631 0.797871 16.7703 0.750719 17.2357 1.15787Z"
      fill={fill}
    />
  </svg>
);
